export const PRIMARY_BACKGROUND_COLOR = "#f4f4f4";
export const PRIMARY_BORDER_COLOR = "#EEE";
export const SNOW = "#FFF";
export const PRIMARY_BUTTON_COLOR = "#467eff";
export const WEAK_FONT_COLOR = "#888";